// extracted by mini-css-extract-plugin
module.exports = {"Toolbar":"Toolbar-module--Toolbar--1iofP","Logo":"Toolbar-module--Logo--bUypT","DesktopOnly":"Toolbar-module--DesktopOnly--1P1tT"};